<template>
  <div class="siderBar">
    <div class="siderBarInner">
<div class="siderBar_li siderBar_li1" @click="goOnlineConsult"><span>在线<br>咨询</span></div>
      
      <div class="siderBar_li siderBar_li4" v-show="scrFlag" @click="toTop()"></div>
    </div>
  </div>
</template>

<script>
  import { WOW } from 'wowjs'
  export default {
    name: 'siderBar',
    data () {
      return {
        scrFlag: false
      }
    },
    created () {
    },

    mounted () {
      let that = this
      // 滚动条滚动
      window.addEventListener('scroll', this.handleScroll)
      //在项目加载完成之后初始化wow
      this.$nextTick(() => {
        let wow = new WOW({
          live: false,
        })
        wow.init()
      })
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
	    
  goOnlineConsult() {
            // 核心：通过JS实现URL跳转
    window.open('https://ccms-api.wulingnev.com:9000/webview.html?token=123456&w=5', '_blank');
        },
      toSupplier(){
        this.$router.push({
            name: 'supplier',
            query: {
            },
          })
      },
      toConsultation(){
       this.$router.push({
            name: 'consultation',
            query: {},
          })
      },
      handleScroll () {
	  
        // 页面滚动距顶部距离
        this.scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        if (this.scrollTop < 200) {
          this.scrFlag = false
        } else {
          this.scrFlag = true
        }
      },
      toTop () {
        let timer = null,
          _that = this
        cancelAnimationFrame(timer)
        timer = requestAnimationFrame(function fn () {
          if (_that.scrollTop > 0) {
            _that.scrollTop -= 150
            document.body.scrollTop = document.documentElement.scrollTop =
              _that.scrollTop
            timer = requestAnimationFrame(fn)
          } else {
            cancelAnimationFrame(timer)
            // _that.goTopShow = false;
          }
        })
      }
    },

  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/siderBar.vue